import { render, staticRenderFns } from "./AmbilGift.vue?vue&type=template&id=62e1777f"
import script from "./AmbilGift.vue?vue&type=script&lang=js"
export * from "./AmbilGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports